import React, { useEffect } from 'react';

import { useConfigStore } from '../../stores';

import PhotoGalleryDetail from '../PhotoGallery/PhotoGalleryDetail/PhotoGalleryDetail';
import { prefetchFloorPlans } from '../FloorPlansPage/prefetchFloorPlans';
import { prefetchMedia } from '../MediaPage/prefetchMedia';
import { prefetchAmenities } from '../AmenitiesPage/prefetchAmenities';
import { prefetchInteractiveMap } from '../InteractiveMapPage/prefetchInteractiveMap';
import { preloadPhoto } from '../../utils/common';

import './HomePage.scss';

const HomePage = () => {
  const config = useConfigStore((state) => state.config);
  const {
    galleryUuid, galleryFirstImage, communityNid, urlSlug,
  } = config || {};

  // Immediately preload first homescreen image when config is available
  // This starts loading before the PhotoGalleryDetail API call completes
  useEffect(() => {
    if (galleryFirstImage) {
      preloadPhoto(galleryFirstImage);
    }
  }, [galleryFirstImage]);

  // Prefetch data for Floor Plans, Media, Amenities, and Interactive Map pages in background
  // This populates the backend cache so these pages load instantly
  // Uses requestIdleCallback to ensure it never interferes with homepage performance
  useEffect(() => {
    // Wait for browser to be idle before prefetching
    // This ensures homepage rendering and user interactions are not affected
    const prefetchCallback = () => {
      // Small additional delay to ensure homepage is fully interactive
      setTimeout(() => {
        // Prefetch all page types in parallel for instant navigation
        // Each function checks if already visited/in-progress before fetching
        prefetchFloorPlans(communityNid, urlSlug);
        prefetchMedia(urlSlug);
        prefetchAmenities(urlSlug);
        prefetchInteractiveMap(urlSlug);
      }, 1000);
    };

    // Use requestIdleCallback with setTimeout fallback for Safari
    let idleHandle;
    if (typeof requestIdleCallback !== 'undefined') {
      idleHandle = requestIdleCallback(prefetchCallback, { timeout: 2000 });
    } else {
      idleHandle = setTimeout(prefetchCallback, 100);
    }

    return () => {
      if (typeof cancelIdleCallback !== 'undefined' && typeof requestIdleCallback !== 'undefined') {
        cancelIdleCallback(idleHandle);
      } else {
        clearTimeout(idleHandle);
      }
    };
  }, [communityNid, urlSlug]);

  return (
    <div className="homescreen">
      <PhotoGalleryDetail
        uuid={galleryUuid}
        galleryClass="homescreenSlideshow"
        imageClass="homescreenSlideshowImage"
      />
    </div>
  );
};

export default HomePage;
